import { useEffect, useState } from "react";

// Tailwind's `lg` is 1024px. Below it the category trees swap to touch-sized
// rows (react-arborist wants a number for the row height, so CSS alone cannot).
const BELOW_LG_QUERY = "(max-width: 1023.98px)";

function matchesBelowLg(): boolean {
  return (
    typeof window.matchMedia === "function" &&
    window.matchMedia(BELOW_LG_QUERY).matches
  );
}

/** True while the viewport is narrower than Tailwind's `lg` breakpoint. */
export default function useIsBelowLg(): boolean {
  const [isBelowLg, setIsBelowLg] = useState(matchesBelowLg);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia(BELOW_LG_QUERY);
    const onChange = () => setIsBelowLg(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isBelowLg;
}
